function PrimaryButton({ children, isLoading = false, ...props }) {
  return (
    <button
      type="button"
      className="w-full rounded-[4px] border border-[#0b7f13] bg-gradient-to-b from-[#16a51f] to-[#0f9518] px-4 py-3 font-login text-[16px] font-bold text-white shadow-button transition hover:brightness-105 active:translate-y-px disabled:cursor-wait disabled:opacity-80"
      disabled={isLoading || props.disabled}
      {...props}
    >
      {isLoading ? 'Ingresando...' : children}
    </button>
  );
}

export default PrimaryButton;
